import { Mic2, Users, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import usePageContent from "@/hooks/usePageContent";
import ScrollReveal from "@/components/ScrollReveal";
import StaggerContainer from "@/components/StaggerContainer";

const TrustHighlights = () => {
  const { t } = useTranslation();
  const { getContent } = usePageContent("home");

  const highlights = [
    {
      icon: Mic2,
      title: getContent("trust_title1", t("trustHighlights.professionalVoices")),
      description: getContent("trust_desc1", t("trustHighlights.professionalVoicesDesc")),
    },
    {
      icon: Users,
      title: getContent("trust_title2", t("trustHighlights.tailoredServices")),
      description: getContent("trust_desc2", t("trustHighlights.tailoredServicesDesc")),
    },
    {
      icon: MapPin,
      title: getContent("trust_title3", t("trustHighlights.canadianExpertise")),
      description: getContent("trust_desc3", t("trustHighlights.canadianExpertiseDesc")),
    },
  ];

  return (
    <section id="about" className="section-padding bg-background">
      <div className="container-wide">
        <StaggerContainer className="grid grid-cols-1 gap-10 sm:grid-cols-3 sm:gap-6 md:gap-8" staggerDelay={0.15}>
          {highlights.map((item, index) => (
            <div 
              key={index} 
              className="text-center group"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 mb-5 sm:mb-6 border border-border rounded-full group-hover:border-primary transition-colors duration-300">
                <item.icon size={24} strokeWidth={1.5} className="text-primary sm:w-7 sm:h-7" />
              </div>
              <h3 className="heading-card mb-2 sm:mb-3 text-primary">{item.title}</h3>
              <p className="text-editorial max-w-xs mx-auto text-[0.9375rem] sm:text-base">{item.description}</p>
            </div>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
};

export default TrustHighlights;
